export const mobileService = 800;


